<template>
  <modal name="securone-edit-sms" class="modal-inner" transition="pop-out" :width="560" height="auto" :adaptive="true" :scrollable="true" :focus-trap="true" @before-close="reset">
    <span class="close-button" @click="$modal.hide('securone-edit-sms')"><BaseIcon icon="times-circle" class="text-white" /></span>
    <div class="modal-header text-lg font-serif">{{ $t("securone.users.edit_sms_contact") }}</div>
    <div class="modal-body" v-if="contact">
      <ValidationObserver ref="form">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full md:w-1/2 px-2 py-2"><BaseInput v-model="form.name" :field_name="$t('securone.invite.name')" rules="required" /></div>
          <div class="w-full md:w-1/2 px-2 py-2"><BaseInput v-model="form.phone" type="tel" :field_name="$t('securone.invite.phone')" rules="required|min:5" /></div>
        </div>
      </ValidationObserver>
      <DepartmentPicker class="mt-2" v-model="form.departmentIds" :label="$t('securone.department.label')" />
      <div class="mt-3" v-if="groups.length">
        <div class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-2">{{ $t("securone.common.groups") }}</div>
        <div class="flex flex-wrap gap-2">
          <label v-for="g in groups" :key="g._id" class="inline-flex items-center gap-2 border rounded px-2 py-1 text-sm cursor-pointer" :class="form.groups.includes(g._id) ? 'border-secondary-400 bg-secondary-50' : 'border-secondary-300'">
            <input type="checkbox" class="form-checkbox h-4 w-4" :value="g._id" v-model="form.groups" />{{ g.name }}
          </label>
        </div>
      </div>
      <SoNote tone="muted" class="mt-3">{{ $t("securone.invite.sms_note") }}</SoNote>
      <SoNote v-if="error" tone="bad" class="mt-3">{{ error }}</SoNote>
    </div>
    <div class="modal-footer">
      <div class="footer-container flex items-center gap-2">
        <button class="sd-btn sd-btn--danger" @click="$emit('remove', contact)"><BaseIcon icon="trash" class="mr-1" />{{ $t("securone.users.remove_contact") }}</button>
        <span class="flex-1"></span>
        <button class="sd-btn sd-btn--secondary" @click="$modal.hide('securone-edit-sms')">{{ $t("securone.common.cancel") }}</button>
        <button class="sd-btn sd-btn--success" :disabled="busy" @click="submit">{{ $t("securone.common.save") }}<BaseIcon icon="save" class="ml-1" /></button>
      </div>
    </div>
  </modal>
</template>

<script>
import SoNote from "./SoNote.vue";
import DepartmentPicker from "./DepartmentPicker.vue";
import api from "../securone.api";
import { errorMessage } from "../securone.helpers";

export default {
  name: "EditSmsContactModal",
  components: { SoNote, DepartmentPicker },
  props: {
    groups: { type: Array, default: () => [] },
  },
  data() {
    return { contact: null, form: { name: "", phone: "", departmentIds: [], groups: [] }, busy: false, error: null };
  },
  methods: {
    open(contact) {
      this.reset();
      this.contact = contact;
      this.form = { name: contact.name, phone: contact.phone, departmentIds: (contact.departmentIds || []).map(String), groups: (contact.groups || []).map((g) => g._id) };
      this.$modal.show("securone-edit-sms");
    },
    reset() {
      this.busy = false;
      this.error = null;
    },
    async submit() {
      if (!(await this.$refs.form.validate())) return;
      if (!this.form.departmentIds.length) {
        this.error = this.$t("securone.department.required");
        return;
      }
      this.busy = true;
      this.error = null;
      try {
        const updated = await api.updateSmsContact(this.contact._id, this.form);
        this.$modal.hide("securone-edit-sms");
        this.$emit("saved", updated);
      } catch (error) {
        this.error = errorMessage(this, error);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
